module.exports = __webpack_public_path__ + "img/3_no.086a869b.svg";